// Import dependencies
import React, {Component} from 'react';
import ReactHowler from "react-howler";
import $ from 'jquery';

// Import css
import './Landing.css';

// Import components
import { TitleText, ParagraphText } from '../components/global/UXLibrary'
import MainButton from "../components/global/buttons/MainButton"
import CityDistortion from "../components/landing/CityDistortion";
import Grid from "../components/global/Grid"
import CityDistortionMobile from "../components/landing/CityDistortionMobile";
import history from '../components/router/history';

// Import images
import logo from '../resources/icons/logo.svg'
import focus from "../resources/sounds/focus.mp3";
import click from "../resources/sounds/click.mp3";


export default class Landing extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            bgDisplay: 'none',
            leaveAnimation: '',
            cityState: 'initial',
            width: 0,
            focusPlaying: false,
            clickPlaying: false
        };
        this.grid = React.createRef();
        this.cityDistortion = React.createRef();
        this.revealBg = this.revealBg.bind(this);
        this.playLeaveAnimation = this.playLeaveAnimation.bind(this);
        this.toggleCityDistortion = this.toggleCityDistortion.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.playFocus = this.playFocus.bind(this);
        this.stopFocus = this.stopFocus.bind(this);
        this.playClick = this.playClick.bind(this);
    }

    // Focuses button with a grid
    focusButton = (event) =>
    {
        // Get bounding rectangle of the button
        let location = event.target.getBoundingClientRect();
        // Update grid
        this.grid.current.focus(location.top, location.bottom, location.left, location.right);
    };
    // Resets grid focus
    resetFocus = () =>
    {
        this.grid.current.updateDimensions();
    };

    // Either assembles or breaks puzzle depending on the current state
    toggleCityDistortion = () =>
    {
        if (this.state.cityState === 'initial') {
            this.cityDistortion.current.showCity();
            this.setState({
                cityState: ''
            });
        }
        else {
            this.cityDistortion.current.hideCity()
        }
    };

    // Changes opacity of the background from 0 to 1
    revealBg()
    {
        this.setState({
            bgDisplay: 'block'
        })
    }

    // Returns random text depending on the class
    randomizeText(text, component)
    {
        let characterCollection = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "Y", "Z"];
        let currentText = text;
        let currentTextCollection = [];
        let characterCount = 0;
        let characterSpeed = this.state.width > 770 ? 300 : 150;

        // Push Current Text Characters
        for (let i = 0; i < currentText.length; i++) {
            let currentCharacter = currentText.slice(i, i+1);
            currentTextCollection.push(currentCharacter);
        }

        let characterCountIncreaseInterval = setInterval(characterCountIncrease, characterSpeed);

        function characterCountIncrease () {
            if (characterCount === currentTextCollection.length) {
                clearInterval(characterCountIncreaseInterval);
                clearInterval(setRandomTextInterval);
            }
            characterCount++;
        }

        function getRandomText () {
            let result = "";

            if (characterCount === 0) {
                for (let i = 0; i < currentTextCollection.length; i++) {
                    result += characterCollection[ Math.floor( Math.random() * characterCollection.length ) ];
                }
            }
            else {
                result = currentText.slice(0, characterCount);

                for (let i = 0; i < currentTextCollection.length - characterCount; i++) {
                    result += characterCollection[ Math.floor( Math.random() * characterCollection.length ) ];
                }
            }
            return result;
        }

        let setRandomTextInterval = setInterval(setRandomText, 25);

        function setRandomText () {
            let newText = getRandomText();
            $(component).text(newText);
        }
    }

    // Animates tag line text
    animateTagLine()
    {
        this.randomizeText($(".landing__tagline-1").text(), ".landing__tagline-1");
        this.randomizeText($(".landing__tagline-2").text(), ".landing__tagline-2");
        this.randomizeText($(".landing__tagline-3").text(), ".landing__tagline-3");
    }

    playLeaveAnimation()
    {
        this.setState({
            leaveAnimation: 'landing__content-leave-animation'
        });

        this.toggleCityDistortion();

        setTimeout(function() {
            history.push('/services');
        }, 2000);
    }

    // Methods for playing and stopping sounds
    playFocus()
    {
        this.setState({ focusPlaying: true });
    }
    stopFocus()
    {
        this.setState({ focusPlaying: false });
    }
    playClick()
    {
        this.setState({ clickPlaying: true });
        setTimeout(function() { this.setState({ clickPlaying: false }) }.bind(this), 100);
    }

    // Updates window dimensions on window resize event
    updateWindowDimensions()
    {
        this.setState({ width: window.innerWidth });
    }

    componentWillMount()
    {
        // Set window resize listener
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount()
    {
        // Execute animation timeline
        // 1. Animate tag line text
        this.animateTagLine();
        // 2.Toggle city of london puzzle
        setTimeout( this.toggleCityDistortion, 2500);
        // 3.Highlight the background
        setTimeout( this.revealBg, 2500);
    }

    componentWillUnmount()
    {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        return (
            <div className='landing__container'>
                {/* Left Side (City of London) */}
                {
                    this.state.width > 770 ?
                        <CityDistortion ref={this.cityDistortion} />
                        :
                        <CityDistortionMobile ref={this.cityDistortion} />
                }

                {
                    this.state.width < 770 ?
                        <img src={logo} className='landing__logo-mobile' alt='RootNode Logo' />
                        :
                        null
                }

                {/* Right Side (Content) */}
                <div className='landing__content'>
                    {/* Content */}
                    <div className={this.state.leaveAnimation} >
                        <div className={'landing__top-bar landing__change-opacity-animation '}>
                            <img src={logo} className='landing__logo' alt='RootNode Logo' />
                        </div>

                        {
                            this.state.width > 770 ?
                                <div>
                                    <TitleText className='landing__tagline-1'>BESPOKE</TitleText>
                                    <TitleText className='landing__tagline-2'>TURNKEY</TitleText>
                                    <TitleText className='landing__tagline-3'>SOLUTIONS</TitleText>
                                </div>
                                :
                                <div>
                                    <TitleText className='landing__tagline-1'>BESPOKE TURNKEY</TitleText>
                                    <TitleText className='landing__tagline-2'>SOLUTIONS</TitleText>
                                </div>
                        }

                        <div className='landing__separator' />

                        <div
                            style={{display: 'inline-block', pointerEvents: 'all'}}
                            onMouseEnter={(event) => {
                                if (this.state.width > 770) {
                                    this.focusButton(event);
                                    this.playFocus();
                                }
                            }}
                            onMouseLeave={() => {
                                if (this.state.width > 770) {
                                    this.resetFocus();
                                    this.stopFocus();
                                }
                            }}
                            onClick={() => {
                                this.playClick();
                                this.playLeaveAnimation();
                            }}
                        >
                            <MainButton title='explore' />
                        </div>
                        <div className='landing__separator' />
                        <div className='landing__description landing__change-opacity-animation'>
                            <ParagraphText>
                                Welcome! We are the Square Mile’s premier digital solutions company. We operate from the financial capital of the world because we’ve been most trusted by our bank clients for websites, applications and critical financial systems.
                                We deliver out of the box services and we guarantee 5x improvements in quality, speed and cost compared to an in-house development. Our ethos is simple; if you succeed, we succeed. We wouldn’t let a lousy product bare our signature.
                            </ParagraphText>
                        </div>
                    </div>
                </div>

                {/* Grid */}
                <Grid ref={this.grid} />

                {/* Top & Bottom Gradients */}
                <div className='landing__gradient-top' />
                <div className='landing__gradient-bottom' />
                <div className={'landing__bg '+this.state.leaveAnimation} style={{ display: this.state.bgDisplay }} />

                {/* Sound Component */}
                {
                    this.state.focusPlaying && this.props.sound ?
                        <ReactHowler
                            src={ focus }
                            playing={ true }
                            preload={ true }
                            ref={(ref) => (this.focus = ref)}
                            autoUnlock={ true }
                            autoSuspend={ false }
                        />
                        :
                        null
                }
                {
                    this.state.clickPlaying && this.props.sound ?
                        <ReactHowler
                            src={ click }
                            playing={ true }
                            preload={ true }
                            ref={(ref) => (this.click = ref)}
                            autoUnlock={ true }
                            autoSuspend={ false }
                        />
                        :
                        null
                }
            </div>
        );
    }
}
